import { useApiQuery } from './useApiQuery';
import { queryKeys } from './queryKeys';
import { prepaymentPoolService } from '@/services/prepaymentPoolService';

// Query hooks
const usePrepaymentPoolSummary = (fundId: string) => {
  return useApiQuery(
    [...queryKeys.prepaymentPool.all, 'summary', fundId],
    () => prepaymentPoolService.getPoolSummary(fundId),
    {
      enabled: !!fundId,
      staleTime: 2 * 60 * 1000, // 2 minutes
    }
  );
};

export const useInvestorPoolsPaginated = (
  fundId: string,
  page: number = 1,
  pageSize: number = 10,
  onlyWithBalance: boolean = true,
  search?: string
) => {
  return useApiQuery(
    [
      ...queryKeys.prepaymentPool.all,
      'investors',
      fundId,
      { page, pageSize, onlyWithBalance, search },
    ],
    () =>
      prepaymentPoolService.getInvestorPoolsPaginated(
        fundId,
        page,
        pageSize,
        onlyWithBalance,
        search
      ),
    {
      enabled: !!fundId,
    }
  );
};

export const useInvestorPrepaymentHistory = (
  fundId: string,
  investorId: string,
  limit: number = 50
) => {
  return useApiQuery(
    [
      ...queryKeys.prepaymentPool.all,
      'investor',
      fundId,
      investorId,
      'history',
      { limit },
    ],
    () => prepaymentPoolService.getInvestorHistory(fundId, investorId, limit),
    {
      enabled: !!fundId && !!investorId,
      staleTime: 2 * 60 * 1000, // 2 minutes
    }
  );
};

// Utility hook for dashboard data
export const usePrepaymentPoolDashboard = (fundId: string) => {
  const summaryQuery = usePrepaymentPoolSummary(fundId);

  return {
    summary: summaryQuery.data?.summary || null,
    investorPools: summaryQuery.data?.investor_pools || [],
    recentTransactions: summaryQuery.data?.recent_transactions || [],
    isLoading: summaryQuery.isLoading,
    isError: summaryQuery.isError,
    error: summaryQuery.error,
    refetch: summaryQuery.refetch,
  };
};
